<template>
  <div>

    <h4 class="alert-heading">Sobre Mi</h4>
    <div class="cuerpo_sobremi mr-3" >
      <p class="m-3">{{nota}}</p>
    </div>

  </div>
</template>

<script>
export default {
name: 'Sobremi',

props:['nota'],
data () {
     return { }
    },
}
</script>

<style>
  .cuerpo_sobremi{
    border: 1px solid blue;
    height: 200px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Sobremi.vue